module.exports = __webpack_public_path__ + "img/6.329341eb.png";